import { Component, PropsWithChildren, ReactNode } from 'react'

import { closeIcon } from '../../incons/icons'

export interface Props {
    id: string              // id da utilizzare nella modale

    titleText: string       // titolo della modae

    isOpen: boolean         // indica se la modale è aperta
    isError?: boolean       // indica se è un modale di errore
    isSuccess?: boolean     // indica se è un modale di successo

    alitgnTop?: boolean

    closeModalCallBack: Function       // funzione per chiudere la modale
}

export interface State {}


class Modal extends Component<PropsWithChildren<Props>, State> {

    constructor (props: any) {
        super(props)

        this.exit = this.exit.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<PropsWithChildren<Props>>, prevState: Readonly<State>, snapshot?: any): void {
        const NO_SCROOL_CLASS = 'no-vertical-scrool'

        if (this.props.isOpen === true && prevProps.isOpen === false) {
            // apro la modale e tolgo lo scrool al body
            document.body.classList.add( NO_SCROOL_CLASS )
        }
        else if (this.props.isOpen === false && prevProps.isOpen === true) {
            // chiudo la modale e ri abilito lo scrool al body
            document.body.classList.remove( NO_SCROOL_CLASS )
        }
    }

    render(): ReactNode {
        const classState = (this.props.isError === true) 
            ? ' modal-error' 
            : ((this.props.isSuccess === true)  ? ' modal-success' : '')

        const classAllign = (this.props.alitgnTop === true)
            ? 'modal-dialog top'
            : 'modal-dialog'

        return (
            (this.props.isOpen) &&
            <div className='modal-container'>
                <div className='modal-fade-show' tabIndex={-1} id={this.props.id}>
                    <div className={ classAllign + classState} >
                        
                        <div className='modal-content'>

                            <div className='modal-header'>
                                
                                <span className='modal-title'>
                                    {this.props.titleText}
                                </span>

                                <button 
                                    type='button'
                                    className='btn-close' 
                                    data-bs-dismiss='modal' 
                                    onClick={this.exit}
                                >
                                    { closeIcon() }
                                </button>
                            </div>

                            <div className='modal-body'>
                                { this.props.children }
                            </div>

                        </div>

                    </div>
                </div>
                <div className={ 'modal-fade-backdrop ' + classState } id={ 'backdrop-' + this.props.id } />
            </div>
        )
    }

    private exit () {
        this.props.closeModalCallBack()
    }
}

export default Modal